<script setup lang="ts">
/** TMP091 — Authority to Issue Shares (DCR + Members' Written Resolution). 2부 문서.
 *  Part 1 DCR 인트로(is_sole/multiple_director_company + resolution_basis)는 OtcDcrIntro,
 *  Part 2 회원 결의 문안은 is_multiple_member(else is_sole_member) 토글. */
import { computed, inject } from 'vue';
import { OTC_DOC_CTX } from './otcContext';
import OtcDocVarField from './OtcDocVarField.vue';
import OtcDocHead from './parts/OtcDocHead.vue';
import OtcDcrIntro from './parts/OtcDcrIntro.vue';
import OtcSigners from './parts/OtcSigners.vue';

const ctx = inject(OTC_DOC_CTX)!;
const multiMember = computed(() => ctx.flag('is_multiple_member'));
const resolutionText =
  'THAT pursuant to Section 75 of the Companies Act, 2016, the Director(s) be and is/are hereby empowered to issue shares in the Company from time to time and upon such terms and conditions and for such purposes as the Director(s) may deem fit and that such authority shall continue in force until not more than twelve months after the approval is given by the members. Such new shares when fully paid will rank pari passu in all respects with existing shares in the Company.';
const memberAgree = computed(() => (multiMember.value
  ? 'We, being the eligible members of the Company (as defined in Section 298 of the Companies Act, 2016) in respect of this written resolution, agree that the Resolution be so passed.'
  : 'I, being an eligible member of the Company (as defined in Section 298 of the Companies Act, 2016) in respect of this written resolution, agree that the Resolution be so passed.'));
</script>

<template>
  <div class="allot-doc">
    <!-- Part 1 — Directors' Circular Resolution -->
    <OtcDocHead />
    <OtcDcrIntro />
    <p class="doc-sec-title">WRITTEN RESOLUTION</p>
    <p class="doc-p">
      That a written resolution pursuant to Section 290 of the Companies Act, 2016 be circulated to all members for the purpose of
      obtaining the members’ approval in respect of the following resolutions :-
    </p>
    <p class="doc-sec-title" style="margin-bottom:2px">ORDINARY RESOLUTION</p>
    <p class="doc-p" style="text-align:center; font-weight:700; margin-bottom:6px">AUTHORITY TO ISSUE SHARES</p>
    <p class="doc-p">{{ resolutionText }}</p>
    <OtcSigners var-key="authority_dcr" board-label="BOARD OF DIRECTORS" />
    <p class="doc-p" style="margin-top:14px"><b>Date:</b> <OtcDocVarField field-key="dcr_date" /></p>

    <!-- Part 2 — Members' Written Resolution -->
    <div class="page-div">— — — Members' Written Resolution — — —</div>
    <OtcDocHead />
    <p class="doc-p">
      Pursuant to Section 290 of the Companies Act, 2016
      <span class="doc-toggle" title="sole / multiple member" @click="ctx.toggleFlag('is_multiple_member')">{{ multiMember ? 'the directors of the Company propose' : 'the director of the Company proposes' }}</span>
      that the following resolution is passed as an ordinary resolution (the “Resolution”)
    </p>
    <p class="doc-sec-title" style="margin-bottom:2px">ORDINARY RESOLUTION</p>
    <p class="doc-p" style="text-align:center; font-weight:700; margin-bottom:6px">AUTHORITY TO ISSUE SHARES</p>
    <p class="doc-p">{{ resolutionText }}</p>

    <p class="doc-lbl-title">AGREEMENT:</p>
    <p class="doc-p">
      <span class="doc-toggle" title="single / multiple member" @click="ctx.toggleFlag('is_multiple_member')">{{ memberAgree }}</span>
    </p>
    <p class="doc-p"><b>Signed By: -</b></p>
    <OtcSigners var-key="authority_members" />

    <p class="doc-p" style="margin-top:14px"><b>Circulation date:</b> &nbsp; <OtcDocVarField field-key="circulation_date" /></p>

    <p class="doc-attn">
      <b>Note:</b> To signify your agreement to the Resolution, you must sign this document where indicated above; return the signed
      document by hand or send it by post to <OtcDocVarField field-key="cosec_name" />,
      <OtcDocVarField field-key="cosec_address" />; ensure that the signed document is received by the
      Company no later than <OtcDocVarField field-key="deadline_date" />. If the Resolution is not passed by this date,
      it will lapse. Once given, your agreement may not be revoked.
    </p>
  </div>
</template>
